import { useAppSelector } from "../../../utils/hooks/store";
import React, { ReactNode } from "react";
import {
  AdminPanelContainer,
  AdminPanelContents,
  AdminPanelTitle,
} from "./AdminPanelStyles";
import Link from "next/link";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../utils/group";
import {
  CUSTOM_PARTS,
  INVENTORY_BINS,
  INVENTORY_UPDATES,
} from "../../../constants/routes";
import FlashPCBExpandable from "../../common/FlashPCBCollapsible";

const AdminPanel = (): ReactNode | null => {
  const { groups } = useAppSelector((state) => state.auth);
  const isAdminOrEngineer =
    groups.includes(ADMIN_GROUP) || groups.includes(ENGINEER_GROUP);

  if (isAdminOrEngineer) {
    return (
      <AdminPanelContainer>
        <FlashPCBExpandable
          renderTrigger={() => <AdminPanelTitle>Admin Panel</AdminPanelTitle>}
        >
          <AdminPanelContents>
            <div>
              <Link href={INVENTORY_BINS}>Manage inventory bins</Link>
            </div>
            <div>
              <Link href={CUSTOM_PARTS}>View custom parts</Link>
            </div>
            <div>
              <Link href={INVENTORY_UPDATES}>Inventory updates</Link>
            </div>
          </AdminPanelContents>
        </FlashPCBExpandable>
      </AdminPanelContainer>
    );
  }
  return null;
};

export default AdminPanel;
